import 'react-app-polyfill/ie11';
import 'core-js/features/array/fill';
import 'core-js/features/array/find';
import 'core-js/features/array/includes';
import 'core-js/features/object/values';
import 'core-js/features/string/includes';
import 'core-js/features/number/is-nan';
import 'core-js/features/url-search-params';
import 'core-js/es/map';
import 'core-js/es/set';
import "core-js/es/weak-map";

export const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
export const isOldEdgeOrIE = !('reversed' in document.createElement('ol'));

// the following custom polyfill for "MutationObserver "is needed to support Browsers like <= IE10;
(function () {
  var MutationObserver;

  if (window.MutationObserver) {
    return;
  }

  MutationObserver = (function () {
    function MutationObserver(callBack) {
      this.callBack = callBack;
    }

    MutationObserver.prototype.observe = function (element, options) {
      this.element = element;
      return this.interval = setInterval((function (_this) {
        return function () {
          var html;
          html = _this.element.innerHTML;
          if (html !== _this.oldHtml) {
            _this.oldHtml = html;
            return _this.callBack.apply(null);
          }
        };
      })(this), 200);
    };

    MutationObserver.prototype.disconnect = function () {
      return window.clearInterval(this.interval);
    };

    return MutationObserver;

  })();

  window.MutationObserver = MutationObserver;

}).call(this);